import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from "@chakra-ui/react";
import { brandPalette } from "../../../constants/brandPalette";
import React from "react";
import { RiSearch2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";

const C = {
  primary: brandPalette.primary,
  secondary: brandPalette.accentDark,
  border: brandPalette.stone,
  muted: "rgba(30, 27, 23, 0.6)",
};

const InactiveStudentsHeader = ({
  searchTerm,
  setSearchTerm,
  inactivePeriod,
  setInactivePeriod,
}) => {
  const count = useSelector((state) => state.students.count);

  return (
    <Box px={{ base: 4, md: 8 }} pt={6} pb={0} w="100%">
      <Flex
        align={{ base: "flex-start", md: "center" }}
        justify="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        mb={6}
      >
        <Box>
          <Text
            fontSize={{ base: "32px", md: "54px" }}
            fontWeight="800"
            color={C.primary}
            fontFamily="'Amiri', 'Tajawal', sans-serif"
            lineHeight="1"
          >
            Inactive students
          </Text>
          <Text mt={3} color={C.muted} fontSize="sm" maxW="2xl">
            Students with no recent activity. Use the period filter and search to narrow the list.
          </Text>
          <Text mt={2} fontSize="sm" fontWeight="700" color={C.secondary}>
            Total matching: {count ?? 0}
          </Text>
        </Box>
      </Flex>

      <Box
        mb={6}
        p={{ base: 4, md: 5 }}
        bg="var(--surface-raised)"
        border="1px solid"
        borderColor={C.border}
        borderRadius="16px"
        boxShadow="sm"
      >
        <Text fontSize="xs" fontWeight="800" color={C.primary} textTransform="uppercase" letterSpacing="0.12em" mb={3}>
          Inactivity period
        </Text>
        <Flex gap={3} flexWrap="wrap" align="center">
          <Button
            size="sm"
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg={inactivePeriod === "oneWeek" ? C.primary : "transparent"}
            color={inactivePeriod === "oneWeek" ? brandPalette.cream : C.secondary}
            fontWeight="800"
            _hover={{
              bg: inactivePeriod === "oneWeek" ? C.secondary : "rgba(216, 206, 195, 0.35)",
            }}
            onClick={() => setInactivePeriod("oneWeek")}
          >
            About 1 week
          </Button>
          <Button
            size="sm"
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg={inactivePeriod === "twoWeeks" ? C.primary : "transparent"}
            color={inactivePeriod === "twoWeeks" ? brandPalette.cream : C.secondary}
            fontWeight="800"
            _hover={{
              bg: inactivePeriod === "twoWeeks" ? C.secondary : "rgba(216, 206, 195, 0.35)",
            }}
            onClick={() => setInactivePeriod("twoWeeks")}
          >
            About 2 weeks
          </Button>
        </Flex>
      </Box>

      <Box mb={6} maxW="520px">
        <InputGroup>
          <InputLeftElement pointerEvents="none" h="full">
            <RiSearch2Fill color="rgba(91, 13, 22, 0.5)" fontSize="18px" />
          </InputLeftElement>
          <Input
            placeholder="Search by name or mobile…"
            value={searchTerm}
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg="var(--surface-raised)"
            pl={10}
            _focus={{ borderColor: C.primary, boxShadow: "0 0 0 1px rgba(91, 13, 22, 0.2)" }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Box>
    </Box>
  );
};

export default InactiveStudentsHeader;
